import { DefaultNodeData, ZapMetadataStep } from "@zapier/canvas-state";
import { AssetTag } from "../AssetTag";
import { AssetName } from "../AssetName";
import { ToggleZapSteps } from "../ToggleZapSteps";
import styles from "./AssetHeading.module.css";

interface Props {
  nodeId: string;
  assetType: "zap" | "table" | "interface" | "chatbot" | undefined;
  tableId?: DefaultNodeData["tableId"];
  interfaceProjectId?: DefaultNodeData["projectId"];
  interfacePageId?: DefaultNodeData["pageId"];
  chatbotId?: DefaultNodeData["chatbotId"];
  isZapExpanded?: boolean;
  onToggleZapSteps?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  zapSteps?: ZapMetadataStep[];
}

export function AssetHeading({
  nodeId,
  assetType,
  tableId,
  interfaceProjectId,
  interfacePageId,
  chatbotId,
  isZapExpanded,
  onToggleZapSteps,
  zapSteps,
}: Props) {
  if (!assetType) {
    return null;
  }

  // This is for all asset types except zaps
  const hasAssetId = Boolean(
    tableId || interfaceProjectId || interfacePageId || chatbotId,
  );

  return (
    <div className={styles.wrapper}>
      <AssetTag assetType={assetType} />
      {hasAssetId && (
        <div className={styles.contentWrapper}>
          <AssetName
            nodeId={nodeId}
            tableId={tableId}
            interfaceProjectId={interfaceProjectId}
            interfacePageId={interfacePageId}
            chatbotId={chatbotId}
          />
        </div>
      )}
      {zapSteps && zapSteps.length > 0 && onToggleZapSteps && (
        <div className={styles.contentWrapper}>
          <ToggleZapSteps
            onClick={onToggleZapSteps}
            isExpanded={Boolean(isZapExpanded)}
            steps={zapSteps}
          />
        </div>
      )}
    </div>
  );
}
